









import Vue from 'vue'
import { mapGetters } from 'vuex'
import { RouteNames } from '@/router'

import type { RawLocation } from 'vue-router'

interface Data {
  appRoute: RawLocation
  loginRoute: RawLocation
  registrationRoute: RawLocation
}

interface Computed {
  isLoggedIn: boolean
}

export default Vue.extend<Data, {}, Computed, {}>({
  data() {
    return {
      appRoute: { name: RouteNames.App, replace: true },
      loginRoute: { name: RouteNames.Login, replace: true },
      registrationRoute: { name: RouteNames.Registration, replace: true },
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
  },
})
